// See: https://material-ui.com/customization/palette/
const palette = {
  default: {
    light: '#F1F1F1',
    main: '#6D6D6D',
    dark: '#575757',
    contrastText: '#fff',
  },
  grey: {
    main: '#BCBCBC',
    transparent: 'rgba(140,152, 178, 0.10)',
  },
  primary: {
    main: '#0E0044',
    light: '#3e3369',
    dark: '#0b0036',
    contrastText: '#fff',
  },
  primaryAlt: {
    main: '#264A9A',
    dark: '#142855',
    contrastText: '#fff',
  },
  secondary: {
    main: '#DB2C73',
    light: '#e2568f',
    dark: '#af235c',
    contrastText: '#fff',
  },
  secondaryAlt: {
    main: '#AA0270',
    dark: '#7E0052',
    contrastText: '#fff',
  },
  tertiary: {
    light: '#3dcdb5',
    main: '#0CC1A3',
    dark: '#0a9a82',
    contrastText: '#fff',
  },
  error: {
    main: '#d1293d',
    light: '#FFEDEF',
    dark: '#921d2b',
    contrastText: '#fff',
  },
  warning: {
    main: '#774000',
    light: '#FFFBD9',
    dark: '#5f3300',
    contrastText: '#fff',
  },
  success: {
    main: '#155724',
    light: '#E6F9E0',
    dark: '#155724',
    contrastText: '#fff',
  },
  info: {
    main: '#0D47A1',
    light: '#E3F2FD',
    dark: '#0D47A1',
    contrastText: '#fff',
  },
  purple: {
    main: '#7D00C0',
    light: '#F9EDFF',
    dark: '#64009a',
    contrastText: '#fff',
  },
  pink: {
    main: '#DB2C73',
    light: '#fbeaf1',
    dark: '#af235c',
    contrastText: '#fff',
  },
  orange: {
    main: '#AA5B00',
    light: '#FCF2E6',
    dark: '#884900',
    contrastText: '#fff',
  },
  violet: {
    main: '#6E668F',
    light: '#8b84a5',
    dark: '#4d4764',
    contrastText: '#fff',
  },
  text: {
    primary: '#0e0044',
    secondary: '#274A9A',
    blue: '#1F1C4F',
    body: '#0e0044',
    muted: '#757578',
  },
  action: {
    disabled: null,
    disabledBackground: null,
  },
  background: {
    default: '#ffffff',
    paper: '#ffffff',
    muted: '#E8E8ED',
  },
  divider: '#707070',
};

const breakpoints = {
  values: {
    xs: 0,
    sm: 768,
    md: 992,
    lg: 1280,
    xl: 1920,
  },
};

// See: https://material-ui.com/customization/typography/
const typography = {
  fontSize: 16,
  fontFamily: '"Montserrat", sans-serif',
  button: {
    fontSize: 16,
    fontFamily: '"Montserrat", sans-serif',
    fontWeight: 600,
  },
  h1: {
    fontSize: 24,
    fontWeight: 600,
    lineHeight: 1.3,
    [`@media (min-width: ${breakpoints.values.md}px)`]: {
      fontSize: 32,
    },
  },
  h2: {
    fontSize: 22,
    fontWeight: 600,
    lineHeight: 1.3,
    [`@media (min-width: ${breakpoints.values.md}px)`]: {
      fontSize: 28,
    },
  },
  h3: {
    fontSize: 18,
    fontWeight: 600,
    lineHeight: 1.3,
    [`@media (min-width: ${breakpoints.values.md}px)`]: {
      fontSize: 24,
    },
  },
  h4: {
    fontSize: 17,
    fontWeight: 600,
    lineHeight: 1.3,
    [`@media (min-width: ${breakpoints.values.md}px)`]: {
      fontSize: 19,
    },
  },
  h5: {
    fontSize: 17,
    fontWeight: 600,
    lineHeight: 1.3,
  },
  h6: {
    fontSize: 13,
    fontWeight: 600,
    lineHeight: 1.3,
  },
  subtitle1: {
    fontSize: 22,
    lineHeight: 'inherit',
    fontWeight: 400,
  },
  subtitle2: {
    fontSize: 18,
    fontWeight: 400,
  },
  body1: {
    fontSize: 16,
    fontWeight: 400,
  },
  body2: {
    fontSize: 14,
    fontWeight: 400,
  },
  size: {
    scale: factor => `${0.25 * factor}em`,
    small: '16px',
    medium: '18px',
    large: '22px',
  },
};

const shape = {
  borderRadius: 4,
};

const components = {
  MuiBackdrop: {
    styleOverrides: {
      root: {
        backgroundColor: 'rgba(39, 50, 74, 0.8)',
      },
    },
  },
  MuiTouchRipple: {
    styleOverrides: {
      root: {
        opacity: 0,
        visiblity: 'hidden',
        display: 'none',
      },
    },
  },
  MuiTooltip: {
    styleOverrides: {
      tooltip: {
        backgroundColor: 'rgba(39, 50, 74, 0.7)',
      },
      arrow: {
        color: 'rgba(39, 50, 74, 0.7)',
      },
    },
  },
};

const spacing = factor => `${0.25 * factor}rem`;

const props = {
  MuiButton: {
    disableRipple: true,
    disableFocusRipple: true,
  },
  MuiButtonBase: {
    disableRipple: true,
    disableFocusRipple: true,
  },
  MuiLoadingButton: {
    disableRipple: true,
    disableFocusRipple: true,
  },
};

const theme = {
  palette,
  typography,
  spacing,
  shape,
  breakpoints,
  props,
  components,
};

export const fontUrl =
  'https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap';

export default theme;
